<template>
    <div class="employee-revenue">
        <div class="row">
            <div :class="{'col-lg-3': selectedRow, 'col-lg-9': !selectedRow}">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="employees.employeeRevenue" />
                        Hvordan er medarbejdernes indtjening?
                    </div>
                    <div class="placeholder">

                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectEmployee"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'" >
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'total_projects'" style="text-align:left;">
                                    {{ props.row.total_projects }}
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'" style="text-align:left;">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'" style="text-align:left;">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>

            <div :class="{'col-lg-3': !selectedRow, 'col-lg-9': selectedRow}">
                
                <div v-if="!selectedRow">
                    Vælg en medarbejder for at se de enkelte opgavetyper og opgaver her
                </div>

                <div v-if="selectedRow">
                    <div style="margin-bottom:5px;">
                        <a href="javascript:void(0)" @click="selectedRow = null; selectedProjectType = null" style="text-decoration:none;color:#172b43;font-weight:600;">
                            <i class="far fa-times" /> Luk
                        </a>
                    </div>
                </div>

                <employee-revenue-project-types :data="selectedRow" v-if="selectedRow" />

            </div>

        </div>
    </div>
</template>

<script>
import * as employeeService from '@/services/employeeService'

export default {
    data () {
        return {
            loading: true,
            rows: [],
            selectedRow: null,
            selectedProjectType: null,
            columns: [
                { label: 'Initialer', field: 'initials', type: 'string' },
                { label: 'Medarbejder', field: 'full_name', type: 'string' },
                { label: 'Antal opgaver', field: 'total_projects', type: 'number' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.selectedRow = null
            this.selectedProjectType = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            employeeService.revenue(params, (response) => {
                this.rows = response.data ? response.data : []
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectEmployee (employee) {
            this.selectedRow = employee.row
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.full_name === this.selectedRow.full_name) {
                return 'selected'
            }
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        data: function () {
            this.getData()
        },
        globalParams: function () {
            this.getData()
        }
    },
    components: {
        'employee-revenue-project-types': require('./employeeRevenueProjectTypes.vue')
    }
}
</script>



// WEBPACK FOOTER //
// employeeRevenue.vue?5c7edbc8